import { Box, FormControl, InputLabel, ListSubheader, MenuItem, Select, TextField } from "@mui/material";
import { useMemo, useState } from "react";
import useStyles from '../../../../../styles/global-mui.js';
// TODO gérer les soucis de boucles d'appel - probablement dans SelectSurveyChoices.js
// console : useControlled.js:19 MUI: A component is changing the uncontrolled value state of Select to be controlled.
// log 'SELECTED player == ', player apparait de plus en plus, plus on ajoute de choix dans le sondage
export const SelectPlayerOrdered = ({ disabled, match, value, onChange, teamId, isFromOtherTeam, custo }) => {
  const [filter, setFilter] = useState("");

  const { groupedPlayers } = useMemo(() => {
    const result = [];

    const processTeam = (teamLabel, labelPrefix) => {
      const allPlayers = match[`${teamLabel}Team`]?.players || [];
      const holders = match[`${teamLabel}Holders`] || [];
      const substitutes = match[`${teamLabel}Substitutes`] || [];

      const others = allPlayers.filter(
        (player) => !holders.some(h => h._id === player._id) &&
                    !substitutes.some(s => s._id === player._id)
      );

      const sortPlayers = (players) => players.sort((a, b) => {
        if (a.numero !== b.numero) return a.numero - b.numero;
        return a.lastname.localeCompare(b.lastname);
      });

      console.log('Titulaires - ', labelPrefix, ' : ', sortPlayers(holders)); 

      result.push({
        label: `Titulaires - ${labelPrefix}`,
        players: sortPlayers(holders)
      });

      result.push({
        label: `Remplaçants - ${labelPrefix}`,
        players: sortPlayers(substitutes)
      });

      if (others.length > 0) {
        result.push({
          label: `Joueurs - ${labelPrefix}`,
          players: sortPlayers(others)
        });
      }
    };

    if (teamId) {
      const teamLabel = match.homeTeam._id === teamId
        ? (isFromOtherTeam ? "away" : "home")
        : match.awayTeam._id === teamId
          ? (isFromOtherTeam ? "home" : "away")
          : null;

      if (teamLabel) {
        processTeam(teamLabel, teamLabel === "home" ? match.homeTeam.name : match.awayTeam.name);
      }
    } else {
      processTeam("home", match.homeTeam.name);
      processTeam("away", match.awayTeam.name);
    }

    return { groupedPlayers: result };
  }, [match, teamId]);

  const normalizedFilter = filter.toLowerCase();

  const classes = useStyles();

  return (
    <Box>
      {!disabled && 
      <Box sx={{pb:'12px'}}>
        <TextField
        className={classes.customInput}
        label="Filtre"
        placeholder="Rechercher un joueur..."
        value={filter}
        onChange={(e) => setFilter(e.target.value)}
        fullWidth
        InputLabelProps={{ shrink: true }}
        size="small"
        >
        </TextField>
        
        </Box>
      }
      <Box>
        <FormControl fullWidth className={classes.customInput} size="small">
          <InputLabel
              id="select-player-label"
              shrink={true}  // force le label à flotter même si value === ""
            >
              Sélection joueur
            </InputLabel>
          <Select
            value={value ?? ''}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            placeholder="Sélectionner un joueur"
            displayEmpty
            renderValue={(selected) => {

                if (!selected || selected === "") return <InputLabel>Sélectionner un joueur</InputLabel>

                // 1. Cherche dans groupedPlayers
                for (const group of groupedPlayers) {
                  const player = group.players.find(p => p._id === selected);
                  // console.log('SELECTED player == ', player);
                  if (player) {
                    return (
                      <>
                        {`${(player.numero!==null && player.numero!==undefined) ? 
                                    player.numero + ' - ' : 
                                     (player.number!==null && player.number!==undefined ? player.number +' - ' : '')}`}
                        {player.lastname.toUpperCase()} {player.firstname}
                      </>
                    );
                  }
                }

                // 2. Cherche dans custo
                if (custo) {
                  const custom = custo.find(c => c._id === selected);
                  if (custom) {
                    return custom.label;
                  }
                }

                return selected; // fallback
              }}
          >
          <MenuItem value="">
            <em>Vider la sélection</em>
          </MenuItem>

            {groupedPlayers.map(({ label, players }) => {
              const filtered = players.filter(player =>
                `${(player.numero!==null && player.numero!==undefined) ? 
                                    player.numero + ' - ' : 
                                     (player.number!==null && player.number!==undefined ? player.number +' - ' : '')}
                 ${player.lastname} ${player.firstname}`
                  .toLowerCase()
                  .includes(normalizedFilter)
              );

              return filtered.length > 0 && [
                <ListSubheader key={label}>{label}</ListSubheader>,
                ...filtered.map((player) => (
                  <MenuItem key={player._id} value={player._id}>
                    {(player.numero ?? player.number) != null ? `${player.numero ?? player.number} - ` : ''}
                    {player.lastname.toUpperCase()} {player.firstname}
                  </MenuItem>
                )),
              ];
            })}

            {custo && custo.length > 0 && [
              <ListSubheader key="custom">Autre</ListSubheader>,
              ...custo
                .filter(c => c.label.toLowerCase().includes(normalizedFilter))
                .map((c) => (
                  <MenuItem key={c._id} value={c._id}>
                    {c.label}
                  </MenuItem>
                )),
            ]}
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};
